import { bandsSaga } from './band.saga';
import { all } from 'redux-saga/effects';
import { rankingSaga } from './ranking.saga';

export default function* rootSaga() {
    yield all([bandsSaga(), rankingSaga()]);
}
